import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const usersApi = createApi({
    reducerPath: "users",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['users', 'DocumentsVerification'],
    endpoints: (builder) => ({

        // ---------------------- USERS ----------------------
        getAllusersList: builder.query({
            query: ({ page, type, search, sortOrder, sortBy, status, limit }) => {
                let url = `admin/users/all?pageno=${page}&search=${search ?? ''}&sortOrder=${sortOrder ?? ''}&sortBy=${sortBy ?? ''}&status=${status ?? ''}&limit=${limit ?? ''}`;
                return {
                    url: url,
                    method: 'GET',
                };
            },
            providesTags: ['users'],
        }),

        getusersByListing: builder.query({
            query: ({ _id, pageno }) => ({
                url: `admin/listings-by-user/${_id}?&page=${pageno + 1}`,
                method: "GET",
            }),
            transformResponse: (res) => ({
                data: res.data,
                total_length: res.data.length > 0 ? res.meta.totalRecords : 0,
            }),
        }),

        updateUserStatus: builder.mutation({
            query: ({ _id, data }) => ({
                url: `/admin/users/${_id}/account-state`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ['users'],
        }),

        getusersBookings: builder.query({
            query: ({ _id, pageno }) => ({
                url: `admin/user-bookings/${_id}?&page=${pageno + 1}`,
                method: "GET",
            }),
            transformResponse: (res) => ({
                data: res.data,
                total_length: res.data.length > 0 ? res.meta.totalRecords : 0,
            }),
        }),

        getusersRentals: builder.query({
            query: ({ _id, pageno }) => ({
                url: `admin/user-rentals/${_id}?&page=${pageno + 1}`,
                method: "GET",
            }),
            transformResponse: (res) => ({
                data: res.data,
                total_length: res.data.length > 0 ? res.meta.totalRecords : 0,
            }),
        }),

        getusersEarnings: builder.query({
            query: ({ _id, pageno }) => ({
                url: `admin/user-earnings/${_id}?&page=${pageno + 1}`,
                method: "GET",
            }),
            transformResponse: (res) => ({
                data: res.data,
                total_length: res.data.length > 0 ? res.meta.totalRecords : 0,
            }),
        }),

        // ---------------------- DOCUMENTS VERIFICATION ----------------------

        getAllDocumentsVerificationList: builder.query({
            query: ({ status, pageno, keyword }) => ({
                url: `admin/documents-verification?status=${status}&page=${pageno + 1}&keyword=${keyword}`,
                method: "GET",
            }),
            transformResponse: (res) => ({
                data: res.data,
                documentsCount: res.meta.documentsCount,
                total_length: res.data.length > 0 ? res.meta.totalRecords : 0,
            }),
            providesTags: ['DocumentsVerification'],
        }),

        updateDocumentsVerificationStatus: builder.mutation({
            query: ({ _id, data }) => ({
                url: `/admin/documents/${_id}/status`,
                method: "PATCH",
                body: data,
            }),
            invalidatesTags: ['DocumentsVerification'],
        }),

        getSupportCount: builder.query({
            query: () => ({
                url: `/admin/support-counts`,
                method: "GET",
            }),
            transformResponse: (res) => res.body
        })
    })
});

export const {
    useGetAllusersListQuery,
    useGetusersByListingQuery,
    useGetusersBookingsQuery,
    useGetusersRentalsQuery,
    useGetusersEarningsQuery,
    useUpdateUserStatusMutation,
    useGetAllDocumentsVerificationListQuery,
    useUpdateDocumentsVerificationStatusMutation,
    useGetSupportCountQuery
} = usersApi;
